import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';
import { AboutComponent } from './components/pages/about/about.component';
import { FeaturesComponent } from './components/pages/features/features.component';
import { TeamComponent } from './components/pages/team/team.component';
import { BlogComponent } from './components/pages/blog/blog/blog.component';
import { BlogDetailsComponent } from './components/pages/blog/blog-details/blog-details.component';
import { ServicesComponent } from './components/pages/services/services/services.component';
import { ServiceDetailsComponent } from './components/pages/services/service-details/service-details.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { LoginComponent } from './components/pages/login/login.component';
import { RegisterComponent } from './components/pages/register/register.component';
import { SolutionsComponent } from './components/pages/solutions/solutions/solutions.component';
import { IndustrialComponent } from './components/pages/solutions/industrial/industrial.component';
import { JoinUsComponent } from './components/pages/join-us/join-us.component';
import { SolutionDetailsComponent } from './components/pages/solutions/solution-details/solution-details.component';

import { NCourComponent } from './components/pages/nCour/nCour.component';

import { DownloadsComponent } from './components/pages/downloads/downloads.component';
import { EnvironmentalComponent } from './components/pages/environmental/environmental.component';
import { SocialComponent } from './components/pages/social/social.component';
import { GovernanceComponent } from './components/pages/governance/governance.component';
import { FilesComponent } from './components/pages/files/files.component';


const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'about', component: AboutComponent},
    {path: 'features', component: FeaturesComponent},
    {path: 'team', component: TeamComponent},
    {path: 'services', component: ServicesComponent},
    {path: 'service-details', component: ServiceDetailsComponent},
    {path: 'news', component: BlogComponent},
    {path: 'news-details', component: BlogDetailsComponent},
    {path: 'faq', component: FaqComponent},
    {path: 'coming-soon', component: ComingSoonComponent},
    {path: 'pricing', component: PricingComponent},
    {path: 'contact', component: ContactComponent},
    {path: 'login', component: LoginComponent},
    {path: 'register', component: RegisterComponent},
    {path: 'solutions', component: SolutionsComponent},
    {path: 'solution-details', component: SolutionDetailsComponent},
    {path: 'NCour', component: NCourComponent},
    {path: 'files', component: FilesComponent},
    {path: 'industrial', component: IndustrialComponent},
    {path: 'join-us', component: JoinUsComponent},
    {path: 'downloads', component: DownloadsComponent},
    {path: 'esg/environmental', component: EnvironmentalComponent},
    {path: 'esg/social', component: SocialComponent},
    {path: 'esg/governance', component: GovernanceComponent},
    
    // Here add new pages component

    {path: '**', component: NotFoundComponent} // This line will remain down from the whole pages component list
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
